/** Layout 50/50 y preservación de scroll en listas Twilio/WhatsApp CRM. */
export default {
  data: () => ({
    pendingChatListScroll: null,
    lastChatListScroll: null,
    cargarMensajes: false,
  }),

  computed: {
    isMobileLayout () {
      return this.$vuetify.breakpoint.width < 600
    },
  },

  methods: {
    getChatListEl () {
      return document.getElementById('preguntas')
    },

    saveChatListScroll () {
      const el = this.getChatListEl()
      return el ? el.scrollTop : 0
    },

    restoreChatListScroll (scrollTop) {
      if (scrollTop == null) return

      const restore = () => {
        const el = this.getChatListEl()
        if (el) el.scrollTop = scrollTop
      }

      this.$nextTick(() => {
        restore()
        this.$nextTick(() => {
          requestAnimationFrame(restore)
        })
      })
    },

    scrollMensajesAlFinal () {
      this.$nextTick(() => {
        requestAnimationFrame(() => {
          const scrollTarget = document.getElementById('scroll-target')
          if (scrollTarget) {
            scrollTarget.scrollTop = scrollTarget.scrollHeight
          }
        })
      })
    },

    onStoreChatListUpdated () {
      if (this.pendingChatListScroll != null) {
        this.restoreChatListScroll(this.pendingChatListScroll)
        this.pendingChatListScroll = null
      }
    },

    beginVerChatScroll () {
      const scrollTop = this.saveChatListScroll()
      this.lastChatListScroll = scrollTop
      this.cargarMensajes = true
      return scrollTop
    },

    finishVerChatScroll (scrollTop) {
      this.pendingChatListScroll = scrollTop
      this.restoreChatListScroll(scrollTop)
      this.scrollMensajesAlFinal()
      this.cargarMensajes = false
    },

    failVerChatScroll (scrollTop) {
      this.restoreChatListScroll(scrollTop)
      this.pendingChatListScroll = null
      this.cargarMensajes = false
    },

    cerrarChatMobile () {
      this.chat = null
      this.mensajes = []
      const scrollTop = this.lastChatListScroll
      this.$nextTick(() => {
        if (scrollTop != null) {
          this.restoreChatListScroll(scrollTop)
        }
      })
    },
  },
}
